import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface StatCardProps {
  icon: LucideIcon;
  label: string;
  value: string;
  /** Optional secondary line. When `up` is true it renders a green ▲ prefix. */
  caption?: string;
  up?: boolean;
}

export function StatCard({ icon: Icon, label, value, caption, up }: StatCardProps) {
  return (
    <div className="rounded-[12px] border border-border-1 bg-bg-1 p-5 shadow-xs">
      <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-fg-3">
        <Icon className="size-4" />
        {label}
      </div>
      <div className="mt-2 font-display text-3xl font-bold text-navy">{value}</div>
      {caption && (
        <div className={cn("mt-1 text-xs", up ? "font-semibold text-success" : "text-fg-3")}>
          {up ? "▲ " : ""}
          {caption}
        </div>
      )}
    </div>
  );
}
